import { render, staticRenderFns } from "./fhir-contact-point.vue?vue&type=template&id=58cdc776&"
import script from "./fhir-contact-point.vue?vue&type=script&lang=js&"
export * from "./fhir-contact-point.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports